import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextField, Button, Card, CardHeader, CircularProgress } from '@material-ui/core';
import { Link } from 'react-router';
import { get } from 'lodash';

import config from '../config';
import { auth, oauth, checkFBRedirect } from '../state/user';
import { colors, formButton } from '../lib/styles';


const styles = {
  container: {
    backgroundAttachment: 'scroll',
    backgroundRepeat: 'repeat',
    height: '100%',
    minHeight: '900px',
    padding: '10px',
  },
  loginBox: {
    margin: '0 auto 100px',
    textAlign: 'center',
    width: '500px',
  },
  errorText: {
    color: colors.secondaryAccent,
    height: '18px',
    paddingTop: '18px',
    margin: '10px'
  },
  form: {
    margin: 'auto',
    padding: '35px 50px 50px',
  },
  loginBrand: {
    height: '18px',
    width: '18px',
    marginRight: '15px'
  },
  loginBrandText: {
    fontSize: '1.2em',
    width: '100%',
    textTransform: 'none',
    textAlign: 'left'
  }
};

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  componentWillMount() {
    this.props.checkFBRedirect()
    .then(() => {
      this.props.router.push('/app');
    })
    .catch((err) => null);
  }

  handleChange(evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  handleLogin() {
    this.props.auth(this.state.email, this.state.password)
      .then(() => {
        this.props.router.push('/app');
      })
  }

  handleOauth(providerId) {
    this.props.oauth(providerId)
      .then((result) => {
        console.log('result', result);
        this.props.router.push('/app');
      })
      .catch((err) => {
        console.log('err with oauth', err);
      })
  }

  render() {
    const { user } = this.props;
    const propErrors = {};
    let errorMsg = '';
    if (user.authError && user.authError.details) {
      user.authError.details.forEach((detail) => {
        propErrors[detail.path] = detail.message;
      });
    } else if (user.authError || user.oauthError) {
      const err = user.authError || user.oauthError;
      // eslint-disable-next-line
      errorMsg = get(err, 'content.message') || get(err, 'content.error') || err.message;
    }
    return (
      <div style={styles.container} >
        {!user.checkFBRedirectPending ? (
            <Card style={styles.loginBox}>
            <CardHeader title="Sign In" />
            <div style={styles.errorText}>{errorMsg}</div>
            <div style={styles.form}>
            {!config.useFBEmailSignup ? (<React.Fragment>
              <TextField
                className="login-field"
                label="email"
                name="email"
                fullWidth={true}
                error={!!propErrors.email}
                onChange={this.handleChange}
                value={this.state.email}
              />
              <TextField
                className="login-field"
                label="Password"
                name="password"
                fullWidth={true}
                error={!!propErrors.password}
                onChange={this.handleChange}
                type="password"
                value={this.state.password}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleLogin}
                style={formButton}
              >Sign In</Button>
              <p style={styles.forgotPassword}><Link to="/signup">New User?</Link></p>
              <p style={styles.forgotPassword}><Link to="/forgot">Forgot your password?</Link></p>
              
              - OR -
              <br/>
              </React.Fragment>) : ''}
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.handleOauth('google.com')}
                style={{margin: '10px', width: '220px', color: '#757575', backgroundColor: '#FFF'}}
              ><img alt="google" style={styles.loginBrand} src="/images/oauth/google.svg"/>
               <span style={styles.loginBrandText}>Sign in with Google</span></Button>
              <br/>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.handleOauth('github.com')}
                style={{margin: '10px', width: '220px', color: '#FFF', backgroundColor: '#333'}}
              ><img alt="github" style={styles.loginBrand} src="/images/oauth/github.svg"/>
              <span style={styles.loginBrandText}>Sign in with Github</span></Button>
              <br/>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.handleOauth('facebook.com')}
                style={{margin: '10px', width: '220px', color: '#FFF', backgroundColor: '#3b5998'}}
              ><img alt="facebook" style={styles.loginBrand} src="/images/oauth/facebook.svg"/>
              <span style={styles.loginBrandText}>Sign in with Facebook</span></Button>
              <br/>
              {config.useFBEmailSignup ? (<Button
                variant="contained"
                color="primary"
                onClick={() => this.props.router.push('/email_signin')}
                style={{margin: '10px', width: '220px', color: '#FFF', backgroundColor: '#db4437'}}
              ><img alt="email" style={styles.loginBrand} src="/images/oauth/mail.svg"/>
              <span style={styles.loginBrandText}>Sign in with Email</span></Button>) : ''}
            
            </div>
            
          </Card>  
        ) : (<CircularProgress/>)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  return { user };
}

export default connect(mapStateToProps, { auth, oauth, checkFBRedirect })(Login);
